import { WOW } from "wowjs";
// mixin主
export const mixin = {
	data(){
	    return {
	        xww:10010,
	        y:200,
			uplink:'http://appapi.hnrqxh.com/app/storage/upload',
			apiUrl:'http://appapi.hnrqxh.com',
			mobile:'',
	    }
	},
    methods:{
		// 跳转外链
		getNewsDetail(url){
		  var tempwindow=window.open('_blank');
		  tempwindow.location=url;
		},
		wlLink(exportUrl){
			console.log(exportUrl)
			if(exportUrl){
				window.open(exportUrl, '_blank'); // 新开窗口下载
			}
		},
		// 去掉时分秒
		quSFM(str){
			if(!str){return}
			str = str.split('T')
			return str[0]
		},
		// 格式化时间
		gsTime(str){
			var today = new Date(str);
			// console.log(today)
			//日期
			var DD = String(today.getDate()).padStart(2, '0'); // 获取日
			var MM = String(today.getMonth() + 1).padStart(2, '0'); //获取月份，1 月为 0
			var yyyy = today.getFullYear(); // 获取年
			// 时间
			var hh =  String(today.getHours()).padStart(2, '0');       //获取当前小时数(0-23)
			var mm = String(today.getMinutes()).padStart(2, '0');     //获取当前分钟数(0-59)
			var ss = String(today.getSeconds()).padStart(2, '0');     //获取当前秒数(0-59)
			var today = yyyy + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
			return today
		},
		//取倒计时（天时分秒）
		getTimeLeft:(datetimeTo) => {
			// 计算目标与现在时间差（毫秒） 时间格式  2021-10-14 00:00:00   
			// ios需转换格式为  2021/10/14 00:00:00
			// ios时间兼容格式转换
			datetimeTo = datetimeTo.replace(new RegExp('-', 'g'), '/');
			// 时间转时间搓
			let time1 = new Date(datetimeTo).getTime();
			let time2 = new Date().getTime();
			let mss = time1 - time2;
			// 倒计时结束
			if (mss < 0) {
				var obj = {
					days: 0,
					hours: 0,
					minutes: 0,
					seconds: 0,
				}
				// return obj
				return false
			}
			// 将时间差（毫秒）格式为：天时分秒
			let days = parseInt(mss / (1000 * 60 * 60 * 24));
			let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
			let seconds = parseInt((mss % (1000 * 60)) / 1000);
			var obj = {
				days: days,
				hours: hours,
				minutes: minutes,
				seconds: seconds,
			}
			return obj
		},
		// 提示框
		Tips(message,type){
			// this.Tips(res.msg,'success')
			this.$message({
				showClose: true,
				message,
				type
			});
		},
		// 路由跳转
		link(url,query={}){
			this.$router.push({path:url,query});
		},
		back(){
			this.$router.back()
		},
		backNub(nub){
			this.$router.go(nub)
		},
    },
	//挂载完毕就执行
	mounted() {
		// var options = {
		// 	boxClass:'wow',// default 在用户滚动时显示隐藏框的类名。
		// 	animateClass:'animated',// default 触发 CSS 动画的类名（默认情况下，animmate.css 库为“animated”）
		// 	offset:0,// default 定义浏览器视口底部与隐藏框顶部之间的距离。当用户滚动并达到此距离时，将显示隐藏框。
		// 	mobile:true,// default 在移动设备上打开/关闭 wow.js。
		// 	live:true,// default 持续检查页面上是否有新的 WOW 元素。
		// };
		// new WOW(options).init();
	},
}
// mixin次
export const shareData = {
    data(){
        return {
            x:10,
            y:20
        }
    }
}
